import React from 'react';
import { Link } from 'react-router';
import Base from 'client/components/base';
import StringStore from 'client/stores/strings';
import baseUrl from 'server/routes/base-url';
import request from 'superagent';
import Notification from 'client/components/common/notification';
import autobind from 'autobind-decorator';

class AcastHubspotEmailSignup extends React.Component {
  componentDidMount() {
    window.hbspt.forms.create({
      portalId: '3841270',
      formId: '129e540f-a45f-4ca2-8ed5-d358e786708f',
      css: '',
      target: '#hubspot-newsletter-form-footer',
    });
  }

  render() {
    return <div id="hubspot-newsletter-form-footer" />;
  }
}

export default class Footer extends Base {
  render() {
    return (
      <footer className={this.css()}>
        <div className="content">
          <div className="logo-and-social">
            <Link to={`${baseUrl}`} className="logo" />
            <div className="social">
              <a
                className="linkedin"
                href={StringStore.get('footer.social.linkedin.link')}
                title={StringStore.get('footer.social.linkedin.title')}
              />
              <a
                className="twitter"
                href={StringStore.get('footer.social.twitter.link')}
                title={StringStore.get('footer.social.twitter.title')}
              />
              <a
                className="facebook"
                href={StringStore.get('footer.social.facebook.link')}
                title={StringStore.get('footer.social.facebook.title')}
              />
            </div>
          </div>
          <div className="contact">
            <h4>{StringStore.get('footer.connect')}</h4>
            <Link to={`${baseUrl}about`}>
              {StringStore.get('footer.about')}
            </Link>
            <a href="https://blog.acast.com/">
              {StringStore.get('header.news')}
            </a>
            <Link to={`${baseUrl}press`}>
              {StringStore.get('footer.press')}
            </Link>
            <a href="mailto:hello@acast.com">
              {StringStore.get('footer.contact')}
            </a>
            <Link to={`${baseUrl}faq`}>{StringStore.get('footer.faq')}</Link>
            <Link to={`${baseUrl}jobs`}>{StringStore.get('footer.jobs')}</Link>
            <a href="http://status.acast.com/" target="_blank">
              {StringStore.get('footer.serviceStatus')}
            </a>
            <Link to={`${baseUrl}privacy`}>
              {StringStore.get('footer.privacy')}
            </Link>
            <Link to={`${baseUrl}terms`}>
              {StringStore.get('footer.terms')}
            </Link>
            <Link to={`${baseUrl}cookies`}>
              {StringStore.get('footer.cookies')}
            </Link>
          </div>
          <div className="newsletter">
            <h4>{StringStore.get('footer.newsletter.title')}</h4>
            <AcastHubspotEmailSignup />
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/footer/footer.es6